import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import AssetCost from './AssetCost';
import AssetCostModel from './AssetCostModel';
import AssetHierarchy from './AssetHierarchy';
import OperationTemplate from '../Settings/OperationTemplate/OperationTemplate';
import { memo, useEffect } from 'react';

function AssetCostModelTabs() {
  const begin = (args: any) => {
    if (args.isSwiped) {
      args.cancel = true;
    }
  };
  return (
    <div>
      <TabComponent heightAdjustMode='Auto' selecting={begin} enablePersistence  statelessTemplates={['directiveTemplates']}>
        <TabItemsDirective>
          <TabItemDirective
            header={{ text: 'Asset Cost Model' }}
            content={() => {
              return <AssetCostModel />;
            }}
          />
          <TabItemDirective
            header={{ text: 'Asset Hierarchy' }}
            content={() => {
              return <AssetHierarchy />;
            }}
          />
          <TabItemDirective
            header={{ text: 'PM Cost Estimation' }}
            content={() => {
              return <AssetCost />;
            }}
          />
          <TabItemDirective
            header={{ text: 'Operation Templates' }}
            content={() => {
              return <OperationTemplate />;
            }}
          />
        </TabItemsDirective>
      </TabComponent> 
    </div>
  );
}

export default memo(AssetCostModelTabs);
